import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import CategoryFilterChips from "../../common/CategoryFilterChips";

export default function ProductAdsCategoryField({
  lang,
  categories,
  loading,
  value,
  onChange,
}) {
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        {lang?.productAdsCategory || "Category"}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        {lang?.productAdsCategoryHint ||
          "Choose the industry or campaign type — used to filter your product ads later."}
      </Typography>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <CategoryFilterChips
          categories={categories}
          value={value || ""}
          onChange={onChange}
          includeAll={false}
          lang={lang}
          emptyHint={
            lang?.productAdsCategoryEmpty ||
            "No categories yet. Ask an admin to add categories under Templates."
          }
        />
      )}
    </Box>
  );
}
